export default {"src":"/_next/static/media/logo.3c0c7cb0.svg","height":1968,"width":2376,"blurWidth":0,"blurHeight":0};